
















































































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class NewBatchSummary extends Vue {
  store = this.$store.direct;

  get name() {
    return this.store.state.batch.selected.name;
  }

  get description() {
    return this.store.state.batch.selected.description;
  }

  get totalRequests() {
    return this.store.state.batch.selected.raw_requests.length;
  }

  get validRequests() {
    return this.store.state.batch.selected.raw_requests.filter(req => {
      return !req.errors || req.errors.length == 0;
    }).length;
  }

  get file() {
    return this.store.state.batch.selected.source
      ? this.store.state.batch.selected.source.name
      : "";
  }

  get size() {
    return this.store.state.batch.selected.source
      ? this.store.state.batch.selected.source.size
      : 0;
  }

  get editedRequests() {
    return this.store.state.batch.selected.raw_requests.filter(req => {
      return req.edited;
    }).length;
  }
}
